import { Controller } from '@hotwired/stimulus'
import { toggle } from 'el-transition'

export default class extends Controller {
  static targets = ['item']

  connect () {
    if (this.checkbox.checked) this.change(this.itemTarget)
  }

  change () {
    toggle(this.itemTarget)
    if (this.itemTarget.dataset.skipbehavior !== 'true') this.itemTarget.required = this.checkbox.checked
  }

  get checkbox () {
    return this.element.querySelector('input[type="checkbox"]')
  }
}
